import { Chip, ChipProps } from "@mui/material";
import React from "react";

import CachedIcon from "@mui/icons-material/Cached";
import CheckIcon from "@mui/icons-material/Check";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { OrderStatus } from "../../../../Core/Api/Types/order-status";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import ApprovalIcon from "@mui/icons-material/Approval";
import HelpIcon from "@mui/icons-material/Help";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { useTranslation } from "react-i18next";

export type OrderStatusProps = {
  status: OrderStatus;
  iconOnly?: boolean;
};

const OrderStatusIcon: React.FC<OrderStatusProps> = (props) => {
  const { t } = useTranslation();
  const { status, iconOnly } = props;
  let color: ChipProps["color"];
  let label = "";
  let icon = <HourglassEmptyIcon fontSize="small" />;

  // TODO: move switch logic do a misc component
  switch (status) {
    case OrderStatus.RUNNING:
      color = "primary";
      icon = <CachedIcon fontSize="small" color="primary" />;
      label = t("common:processing");
      break;
    case OrderStatus.QUEUED:
    case OrderStatus.CREATED:
      color = "primary";
      icon = <HourglassEmptyIcon fontSize="small" color="primary" />;
      label = t("common:pending");
      break;
    case OrderStatus.READY:
      color = "primary";
      icon = <AlarmOnIcon fontSize="small" color="primary" />;
      label = t("common:ready");
      break;
    case OrderStatus.COMPLETED:
      color = "success";
      icon = <CheckIcon fontSize="small" color="success" />;
      label = t("common:delivered");
      break;
    case OrderStatus.FAILED:
    case OrderStatus.ABORTED:
      color = "warning";
      icon = <SettingsOutlinedIcon fontSize="small" color="warning" />;
      label = t("common:fixing");
      break;
    case OrderStatus.MANUAL_DELIVERY_BEFORE_COMPLETED:
      color = "warning";
      icon = <AirportShuttleIcon fontSize="small" color="warning" />;
      label = t("common:manualDelivery");
      break;
    case OrderStatus.CANCELED:
      color = "info";
      icon = <CancelPresentationIcon fontSize="small" color="info" />;
      label = t("common:cancelled");
      break;
    case OrderStatus.QUOTE_PROPOSED:
      color = "info";
      icon = <HelpIcon fontSize="small" />;
      label = t("chip:label.quoteProposal");
      break;
    case OrderStatus.WAITING_APPROVAL:
      color = "info";
      icon = <ApprovalIcon fontSize="small" />;
      label = t("chip:label.waitingForApproval");
      break;
    case OrderStatus.QUOTE_REQUESTED:
      color = "info";
      icon = <EmojiPeopleIcon fontSize="small" />;
      label = t("common:quoteRequested");
      break;
    case OrderStatus.QUOTE_ACCEPTED:
      color = "info";
      icon = <HowToRegIcon fontSize="small" />;
      label = t("common:quoteAccepted");
      break;
    case OrderStatus.QUOTE_DECLINED:
      color = "info";
      icon = <ThumbDownAltIcon fontSize="small" />;
      label = t("common:quoteDeclined");
      break;
    default:
      color = "default";
      label = t("common:pending");
      break;
  }

  return !iconOnly ? <Chip variant="outlined" label={label} color={color} icon={icon} /> : icon;
};

export default OrderStatusIcon;
